<template>
    <div class="AccountGroupConfig">
        <div class="AccountGroupConfig-title">
            <Breadcrumb>
                <BreadcrumbItem>{{currentName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.accountGroupName}}</BreadcrumbItem>
                <BreadcrumbItem to="/permissionsConfigurationManagement/accountGroup">{{ $t('RIAccountGroupManagement.title') }}</BreadcrumbItem>
            </Breadcrumb>
        </div>
        <div class="AccountGroupConfig-top">
            <add-account></add-account>
        </div>
        <table-account-group-config></table-account-group-config>
    </div>
</template>

<script>
    import {getCookie} from '../../../../utils/cookieUtil.js'
    import AddAccount from '../account_group/AddAccount'
    import TableAccountGroupConfig from '../account_group/TableAccountGroupConfig'

    export default {
        name: 'AccountGroupConfig',
        components: {
            AddAccount,
            TableAccountGroupConfig
        },
        data() {
            return {
                currentName: ''
            }
        },
        mounted: function () {
            this.init()
        },
        methods: {
            init: function () {
                this.currentName = getCookie(global.cookieName);
            }
        }
    }
</script>

<style scoped>
    .AccountGroupConfig-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
    .AccountGroupConfig-top
    {
        width: 100%;
        height: 53px;
        background-color: #fff;
        padding: 4px 0px 15px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/account_group/AccountGroupConfig.vue